import { render, staticRenderFns } from "./SelectTypePrintCertificate.vue?vue&type=template&id=2b89cd3e&"
import script from "./SelectTypePrintCertificate.vue?vue&type=script&lang=js&"
export * from "./SelectTypePrintCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports